﻿<script lang="ts" setup>
    import { reactive, onMounted, watch } from 'vue';
    import { type Contact } from './Contact.access';
    import { type Category } from './Contact.access';
    import Form from '@cwd/shared/Components/Form/Form.vue';
    import { FormProps, isEmpty } from '@cwd/shared/components/Form/Form';

    const props = defineProps<{
        contact: Contact;
        categories: Category[];
        submitting: boolean;
    }>();

    const state = reactive<{
        form: FormProps;
    }>({
        form: {
            data: {},
        },
    });

    const emit = defineEmits(['update:modelValue', 'onSubmitSingleInput']);

    onMounted(async () => {
        setup();

        watch(
            () => props.contact,
            (newVal) => {
                newVal && setup();
            }
        );
    });

    const setup = () => {
        props.categories.forEach((category: Category) => {
            let disabled = props.contact.Categories.find((cat: Category) => {
                return cat.CategoryId === category.CategoryId;
            });

            state.form.data[category.CategoryId] = {
                modelValue: disabled ? false : true,
                checkbox: {
                    label: category.Name,
                    switchStyle: 'red-to-green',
                    description: category.Description,
                },
            };
        });
    };

    const getList = (id: string, checked: any) => {
        (state.form.data as any)[id].modelValue = checked;

        let catIndex: number = -1;

        let newVal = props.contact.Categories.map((category: Category, index: number) => {
            if (category.CategoryId === id) catIndex = index;

            return {
                CategoryId: category.CategoryId,
                Description: category.Description,
                Name: category.Name,
            };
        });

        if (checked) {
            newVal.splice(catIndex, 1);
        } else {
            let categoryToAdd = props.categories.find((category: Category) => {
                return category.CategoryId === id;
            });

            categoryToAdd && newVal.push(categoryToAdd);
        }

        return newVal;
    };

    const update = (id: string, checked: any) => {
        (state.form.data as any)[id].modelValue = checked;
        emit('update:modelValue', getList(id, checked));
    };
</script>

<script lang="ts"></script>

<template>
    <h2 class="h4">{{ $Resources.ContactModalSubscriptionsTabHeading }}</h2>

    <Form
        v-if="!isEmpty(state.form.data)"
        :data="state.form.data"
        :submitting="props.submitting"
        :saveOnChange="true"
        @update:modelValue="(id, checked) => update(id, checked)"
        @onSubmitSingleInput="() => $emit('onSubmitSingleInput')"></Form>
</template>

<style></style>
